import React from 'react';
import { View, Text, Image } from 'react-native';
import Icon from '../../../Icon';
import utils from '../utils';
// import currencyMap from '../../../../constant/currencyMap';
import currencyMap from '../../../../Constant/currencyMap';
import { enabledStyle, disabledStyle } from '../commonStyles';
import QImageSet from '../../../../assets/QImageSet.js';

const statusMap: { [propName: string]: string } = {
    10: 'isWarning',
    11: 'isWarning',
    500050: 'isWarning'
};

const appActionMap = {
    pay: true,
    insure: true
};

class Carcar extends QComponent<{ data: any }> {
    public static formatData = (data: any) => {
        const newData = { ...data };
        // title
        newData.title = newData.orderTitle || '用车自驾';
        // icon
        newData.iconfont = '\uf1f3';
        newData.iconColor = '#22bbe9';
        // 价格
        newData.isCommonPriceTpl = false;
        newData.dynamicCurrency = newData.dynamicCurrency
            ? (newData.dynamicCurrency || '').trim()
            : '&yen;';
        newData.fixDynamicPrice = utils.fixPrice(newData.dynamicPrice, newData.dynamicCurrency);

        if (newData.dynamicCurrency !== '&yen;') {
            newData.dynamicCurrency = `${newData.dynamicCurrency}`;
        }
        // 截止黄条
        newData.deadlineNotice = newData.yellowTip || '';
        // 灰条提示
        newData.greyTipNotice = newData.greyTip || '';
        // 状态
        newData._orderStatus = statusMap[newData.status];
        // 按钮
        newData.actionInfos = utils.buildActionInfos(newData.appAction, appActionMap);

        newData.date = utils.buildDateTime(newData.date);
        newData.dateTimeInfo = (formatDate(newData.date) || '').trim();
        if (Number(newData.sysCode) === 7010) { //向导业务
            newData.iconfont = '\uead0';
            newData.carType = 'tourGuide';
        } else if (newData.selfDriveList) {
            newData.carType = 'selfDrive';
            newData.fixFromDate = utils.buildDateTime(newData.selfDriveList.fromDate);
            newData.fixToDate = utils.buildDateTime(newData.selfDriveList.toDate);
        } else if (newData.lineCarList && newData.lineCarList.length > 0) {
            newData.carType = 'lineCar';
            newData.lineCarList = newData.lineCarList.map((lineCar: any) => ({
                ...lineCar,
                fixDate: formatDate(utils.buildDateTime(lineCar.date))
            }));
        } else if (Number(newData.orderType) === 7001219) {
            newData.carType = 'drivingLicense';
        } else if (Number(newData.orderType) === 7005001) {
            newData.carType = 'homeCharter';
            newData.price = utils.fixPrice(newData.price);
        } else if (Number(newData.orderType) === 7009001) {
            newData.carType = 'charter';
            newData.originPayAmount = utils.fixPrice(newData.originPayAmount);
            newData.extraPayAmount = utils.fixPrice(newData.extraPayAmount);
        } 
        else {
            newData.carType = 'common';
        }
        return newData;
    };

    public render() {
        const { data = {} } = this.props;
        const {
            productTitle,
            date,
            carType,
            driverName,
            fixFromDate,
            selfDriveList,
            fixToDate,
            lineCarList,
            carInfo,
            dateTimeInfo,
            from,
            to,
            passengerCount,
            pickupAddress,
            duration,
            useTime,
            productName,
            dynamicCurrency,
            fixDynamicPrice,
            showDiscountIcon,
            showCouponIcon,
            dynamicPriceName,
            dynamicPrice,
            price,
            guaranteeInfo,
            greyTipNotice,
            _disable,
            returnTime,
            originPayAmount,
            extraPayAmount,
            pickupTitle,
            arriveTitle,
            payDesc
        } = data;

        const styles = _disable ? disabledStyle : enabledStyle;

        return (
            <View style={styles.flex1}>
            <View style={styles.contentWrapper}>
                <View style={styles.left}>
                    {(() => {
                        switch (carType) {
                            case 'tourGuide':
                                return (
                                    <View>
                                        <Text style={styles.newOrderTitle} numberOfLines={2}>
                                            {productName}
                                        </Text>
                                        <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                            {useTime}
                                        </Text>
                                    </View>
                                );
                            case 'drivingLicense':
                                return (
                                    <View>
                                        <Text style={styles.newOrderTitle} numberOfLines={2}>
                                            {productTitle}
                                        </Text>
                                        <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                            {driverName}
                                        </Text>
                                    </View>
                                );
                            case 'selfDrive':
                                return (
                                    <View>
                                        {Boolean(fixFromDate) && (
                                            <View style={styles.rowWithIcon}>
                                                <View style={styles.textIconWrapper}>
                                                    <Text
                                                        style={[styles.textIcon, { color: '#fff' }]}
                                                    >
                                                        取
                                                    </Text>
                                                </View>
                                                <Text
                                                    style={[styles.newOrderTitle, styles.flex1]}
                                                    numberOfLines={1}
                                                >
                                                    {fixFromDate}
                                                </Text>
                                            </View>
                                        )}
                                        {Boolean(selfDriveList.getFrom) && (
                                            <Text
                                                style={[styles.newOrderSubTitle, styles.ml22]}
                                                numberOfLines={1}
                                            >
                                                {selfDriveList.getFrom}
                                            </Text>
                                        )}

                                        {Boolean(fixToDate) && (
                                            <View style={[styles.rowWithIcon, styles.mt16]}>
                                                <View style={[styles.textIconWrapper, styles.back]}>
                                                    <Text
                                                        style={[styles.textIcon, { color: '#fff' }]}
                                                    >
                                                        还
                                                    </Text>
                                                </View>
                                                <Text
                                                    style={[styles.newOrderTitle, styles.flex1]}
                                                    numberOfLines={1}
                                                >
                                                    {fixToDate}
                                                </Text>
                                            </View>
                                        )}
                                        {Boolean(selfDriveList.giveBack) && (
                                            <Text
                                                style={[styles.newOrderSubTitle, styles.ml22]}
                                                numberOfLines={1}
                                            >
                                                {selfDriveList.giveBack}
                                            </Text>
                                        )}
                                        {Boolean(selfDriveList.agent) && (
                                            <Text
                                                style={[styles.newOrderSubTitle, styles.ml22]}
                                                numberOfLines={1}
                                            >
                                                {selfDriveList.agent}
                                            </Text>
                                        )}
                                    </View>
                                );
                            case 'lineCar':
                                return (
                                    <View>
                                        {lineCarList.map(
                                            (
                                                lineCar: {
                                                    isStart: boolean;
                                                    isReturn: boolean;
                                                    fixDate: string;
                                                    from: string;
                                                    to: string;
                                                    startAddr: string;
                                                },
                                                index: number
                                            ) => (
                                                <View
                                                    style={
                                                        index === lineCarList.length - 1
                                                            ? null
                                                            : styles.ticketItemWithSiblings
                                                    }
                                                    key={index}
                                                >
                                                    <View style={styles.rowWithIcon}>
                                                        {Boolean(lineCar.isStart) && (
                                                            <View style={styles.textIconWrapper}>
                                                                <Text
                                                                    style={[
                                                                        styles.textIcon,
                                                                        { color: '#fff' }
                                                                    ]}
                                                                >
                                                                    去
                                                                </Text>
                                                            </View>
                                                        )}
                                                        {Boolean(lineCar.isReturn) && (
                                                            <View
                                                                style={[
                                                                    styles.textIconWrapper,
                                                                    styles.back
                                                                ]}
                                                            >
                                                                <Text
                                                                    style={[
                                                                        styles.textIcon,
                                                                        { color: '#fff' }
                                                                    ]}
                                                                >
                                                                    返
                                                                </Text>
                                                            </View>
                                                        )}
                                                        {Boolean(lineCar.fixDate) && (
                                                            <Text
                                                                style={[
                                                                    styles.newOrderTitle,
                                                                    styles.flex1
                                                                ]}
                                                                numberOfLines={1}
                                                            >
                                                                {lineCar.fixDate}
                                                            </Text>
                                                        )}
                                                    </View>
                                                    {lineCar.from || lineCar.to ? (
                                                        lineCar.isStart || lineCar.isReturn ? (
                                                            <View>
                                                                <Text
                                                                    style={[
                                                                        styles.newOrderSubTitle,
                                                                        styles.ml22
                                                                    ]}
                                                                    numberOfLines={1}
                                                                >
                                                                    {Boolean(lineCar.from) &&
                                                                        `${lineCar.from}${
                                                                            lineCar.to ? ' ' : ''
                                                                        }`}
                                                                    {Boolean(
                                                                        lineCar.from && lineCar.to
                                                                    ) && (
                                                                        <Icon
                                                                            code="&#xe6c2;"
                                                                            size={12}
                                                                        />
                                                                    )}
                                                                    {Boolean(lineCar.to) &&
                                                                        `${
                                                                            lineCar.from ? ' ' : ''
                                                                        }${lineCar.to}`}
                                                                </Text>

                                                                {Boolean(lineCar.startAddr) && (
                                                                    <Text
                                                                        style={[
                                                                            styles.newOrderSubTitle,
                                                                            styles.ml22
                                                                        ]}
                                                                        numberOfLines={1}
                                                                    >
                                                                        {`上车点  ${lineCar.startAddr}`}
                                                                    </Text>
                                                                )}
                                                            </View>
                                                        ) : (
                                                            <View>
                                                                <Text
                                                                    style={styles.newOrderSubTitle}
                                                                    numberOfLines={1}
                                                                >
                                                                    {Boolean(lineCar.from) &&
                                                                        `${lineCar.from}${
                                                                            lineCar.to ? ' ' : ''
                                                                        }`}
                                                                    {Boolean(
                                                                        lineCar.from && lineCar.to
                                                                    ) && (
                                                                        <Icon
                                                                            code="&#xe6c2;"
                                                                            size={12}
                                                                        />
                                                                    )}
                                                                    {Boolean(lineCar.to) &&
                                                                        `${
                                                                            lineCar.from ? ' ' : ''
                                                                        }${lineCar.to}`}
                                                                </Text>
                                                                {Boolean(lineCar.startAddr) && (
                                                                    <Text
                                                                        style={
                                                                            styles.newOrderSubTitle
                                                                        }
                                                                        numberOfLines={1}
                                                                    >
                                                                        {`上车点  ${lineCar.startAddr}`}
                                                                    </Text>
                                                                )}
                                                            </View>
                                                        )
                                                    ) : null}
                                                </View>
                                            )
                                        )}
                                    </View>
                                );
                            case 'common':
                                return (
                                    <View>
                                        {Boolean(dateTimeInfo) && (
                                            <Text style={styles.newOrderTitle} numberOfLines={2}>
                                                {dateTimeInfo}
                                            </Text>
                                        )}
                                        {Boolean(from) && (
                                            <View style={styles.rowWithIcon}>
                                                <View
                                                    style={[
                                                        styles.dot,
                                                        dateTimeInfo ? null : styles.mb6
                                                    ]}
                                                />
                                                <Text
                                                    numberOfLines={1}
                                                    style={[
                                                        dateTimeInfo
                                                            ? styles.newOrderSubTitle
                                                            : styles.newOrderTitle,
                                                        styles.flex1
                                                    ]}
                                                >
                                                    {from}
                                                </Text>
                                            </View>
                                        )}
                                        {Boolean(to) && (
                                            <View style={styles.rowWithIcon}>
                                                <View
                                                    style={[
                                                        styles.dot,
                                                        styles.dotDist,
                                                        dateTimeInfo ? null : styles.mb6
                                                    ]}
                                                />
                                                <Text
                                                    numberOfLines={1}
                                                    style={[
                                                        dateTimeInfo
                                                            ? styles.newOrderSubTitle
                                                            : styles.newOrderTitle,
                                                        styles.flex1
                                                    ]}
                                                >
                                                    {to}
                                                </Text>
                                            </View>
                                        )}
                                        {Boolean(passengerCount) && (
                                            <Text
                                                numberOfLines={1}
                                                style={[styles.newOrderSubTitle, styles.ml14]}
                                            >
                                                {`${passengerCount}人乘坐`}
                                            </Text>
                                        )}
                                        {Boolean(carInfo) && (
                                            <Text
                                                numberOfLines={1}
                                                style={[styles.newOrderSubTitle, styles.ml14]}
                                            >
                                                {carInfo}
                                            </Text>
                                        )}
                                    </View>
                                );
                            case 'homeCharter':
                                return (
                                    <View>
                                        {Boolean(pickupAddress) && (
                                            <Text style={styles.newOrderTitle} numberOfLines={1}>
                                                {`${pickupAddress}上车`}
                                            </Text>
                                        )}
                                        {Boolean(duration || useTime) && (
                                            <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                                {`${useTime || ''}${
                                                    duration ? ` ${duration}天` : ''
                                                }`}
                                            </Text>
                                        )}
                                        {Boolean(productName) && (
                                            <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                                {productName}
                                            </Text>
                                        )}
                                    </View>
                                );
                            case 'charter':
                                return (
                                    <View>
                                        {Boolean(pickupAddress) && (
                                            <Text style={styles.newOrderTitle} numberOfLines={1}>
                                                 {productName}
                                            </Text>
                                        )}
                                        {useTime && (
                                            <View>
                                                <View style={styles.rowWithIcon}>
                                                    <Image source={{uri: _disable ? QImageSet.disable_into_car_icon : QImageSet.into_car_icon }} style={styles.carIcon} />
                                                    <Text
                                                        numberOfLines={1}
                                                        style={[
                                                            styles.newOrderSubTitle,
                                                            styles.flex1
                                                        ]}
                                                    >
                                                        {useTime}
                                                    </Text>
                                                </View>
                                                <Text
                                                    numberOfLines={1}
                                                    style={[
                                                        styles.newOrderSubTitle,
                                                        styles.flex1,
                                                        { marginLeft: 20 }
                                                    ]}
                                                >
                                                    {pickupTitle}
                                                </Text>
                                            </View>
                                        )}
                                        {returnTime && (
                                            <View>
                                                <View style={styles.rowWithIcon}>
                                                    <Image source={{uri: _disable ? QImageSet.disable_out_car_icon : QImageSet.out_car_icon }} style={styles.carIcon} />
                                                    <Text
                                                        numberOfLines={1}
                                                        style={[
                                                            styles.newOrderSubTitle,
                                                            styles.flex1
                                                          ]}
                                                    >
                                                        {returnTime}
                                                    </Text>
                                                </View>
                                                <Text
                                                    numberOfLines={1}
                                                    style={[
                                                        styles.newOrderSubTitle,
                                                        styles.flex1,
                                                        { marginLeft: 20 }
                                                    ]}
                                                >
                                                    {arriveTitle}
                                                </Text>
                                            </View>
                                        )}
                                    </View>
                                );
                            default:
                                return null;
                        }
                    })()}
                    {Boolean(greyTipNotice) && (
                        <View style={styles.rowWithIcon}>
                            <Icon code="&#xf0fc;" style={styles.greyTipNoticeIcon} />
                            <Text
                                style={[styles.greyTipNoticeText, styles.flex1]}
                                numberOfLines={1}
                            >
                                {greyTipNotice}
                            </Text>
                        </View>
                    )}
                </View>
                <View style={styles.right}>
                    {Boolean(dynamicPrice) && (
                        <Text style={styles.orderPriceWrapper} numberOfLines={1}>
                            <Text style={styles.orderPriceCurrency}>
                                {`${dynamicPriceName || ''} ${currencyMap[dynamicCurrency] || ''}`}
                            </Text>
                            <Text style={styles.orderPrice}>{fixDynamicPrice}</Text>
                        </Text>
                    )}
                    {Boolean(showDiscountIcon || showCouponIcon) && (
                        <View style={styles.priceTextIconBox}>
                            {Boolean(showDiscountIcon) && (
                                <View style={styles.priceTextIconWrapper}>
                                    <Text style={styles.priceTextIconText}>折</Text>
                                </View>
                            )}
                            {Boolean(showCouponIcon) && (
                                <View style={[styles.priceTextIconWrapper, styles.coupon]}>
                                    <Text style={[styles.priceTextIconText, styles.couponText]}>
                                        券
                                    </Text>
                                </View>
                            )}
                        </View>
                    )}
                    {Boolean(guaranteeInfo) && (
                        <Text
                            style={[styles.orderPriceWrapper, styles.orderPriceConvert]}
                            numberOfLines={1}
                        >
                            {guaranteeInfo}
                        </Text>
                    )}
                    {carType === 'homeCharter' && Boolean(price) && (
                        <Text
                            style={[styles.orderPriceWrapper, styles.orderPrice]}
                            numberOfLines={1}
                        >
                            <Text style={styles.orderPriceCurrency}>&yen;</Text> 
                            {price}
                        </Text>
                    )}
                    {carType === 'charter' && Boolean(originPayAmount) && (
                        <>
                            <Text
                                style={[styles.orderPriceWrapper, styles.orderPrice]}
                                numberOfLines={1}
                            >
                                <Text style={styles.orderPriceCurrency}>&yen;</Text> 
                                {Boolean(extraPayAmount) ? extraPayAmount : originPayAmount}
                            </Text>
                            {Boolean(extraPayAmount)
                                && <Text
                                    style={[styles.orderPriceWrapper, styles.originOrderPrice]}
                                    numberOfLines={1}
                                >
                                    <Text style={styles.orderExtraPriceCurrency}>&yen;</Text> 
                                    {originPayAmount}
                            </Text>}
                        </>
                    )}
                </View>                
            </View>
            {Boolean(payDesc) && (
                <View style={[styles.cardProgress,{
                    backgroundColor: _disable ? '#F7F8FA' : '#F2FCFD'
                }]}>
                    <Text style={styles.cardProgressTitle}>支付明细</Text>
                    <Text style={styles.cardProgressDesc}>{payDesc}</Text>
                </View>
            )}
            </View>
        );
    }
}

const formatDate = (date: string) => {
    let info = date.split(' ') || [];
    if (info && info.length > 0) {
        const [a, b, c, ...d] = info;
        info = [a, c, b, ...d];
    }
    return info.join(' ');
};

export default Carcar;
